import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from "../../../app/ui/modal/v4/v4";

import ModalOptionsSelection from '../../gd-components/modal-options-selection/modal-options-selection';

import {when} from 'simply-deferred';
import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";

module.exports = class ModalAddTodoList extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            companyId: PropTypes.string.isRequired,
            onSubmit: PropTypes.func.isRequired
        }),
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        when(gd.session.todoListTemplates).then(()=>{
            this.templates = gd.session.todoListTemplates.filterByCompany(this.props.params.companyId);

            this.refs.modalOptionsSelection.setOptions(this.templates.map(t=>({id:t.id, label:t.name})));
        })
    }

    onSelectTemplate = (id) => {
        const todoTemplate = gd.session.todoListTemplates.get(id);
        this.props.params.onSubmit(todoTemplate.name, todoTemplate.todoList);
    }

    onManageTodoTemplates = () => {
        gd.goTo('settings/todo-list');
    }

    render() {
        const isManager = gd.ac.check.company.isManager(this.props.params.companyId);

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>

                <ModalV4Header height={60} title="New ToDo list from template" />

                <ModalOptionsSelection ref="modalOptionsSelection"
                                       className="form-container"
                                       options={this.templates ? this.templates.map(t=>({id:t.id, label:t.name})) : null}
                                       onSelectOption={this.onSelectTemplate}>
                    {isManager &&
                    <div key="manage" className="todo-manage" onClick={this.onManageTodoTemplates}>
                        <div className="modal-options-item-label">
                            Manage templates
                        </div>
                    </div>}
                </ModalOptionsSelection>
            </div>
        )
    }
};